export const formatIDR = (n) => {
  const val = Number(n || 0);
  return "Rp " + val.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const formatShortIDR = (n) => {
  const val = Number(n || 0);
  if (Math.abs(val) >= 1_000_000_000) return "Rp " + (val / 1_000_000_000).toFixed(1) + " M";
  if (Math.abs(val) >= 1_000_000) return "Rp " + (val / 1_000_000).toFixed(1) + " jt";
  if (Math.abs(val) >= 1_000) return "Rp " + (val / 1_000).toFixed(0) + " rb";
  return "Rp " + val.toLocaleString("id-ID");
};

export const formatNumber = (n) => Number(n || 0).toLocaleString("id-ID");

export const formatDateID = (iso) => {
  if (!iso) return "";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
};

export const toDateInput = (d) => {
  const dt = d instanceof Date ? d : new Date(d);
  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const todayISO = () => toDateInput(new Date());
